import {Heading, useColorModeValue} from "@chakra-ui/react";
import {Link as GatsbyLink} from "gatsby";
import React from "react";

const Title = () => {
  return (
    <Heading fontWeight={600} fontSize={'6xl'} lineHeight={'100%'} letterSpacing={4}
             bg={useColorModeValue('linear-gradient(145deg, #2A9D8F, #75a786)', 'linear-gradient(145deg, #2A9D8F, #e9c46a)')}
             backgroundClip={'text'}
    >
      <GatsbyLink to={'/'}>
        The Good Code<br/>
      </GatsbyLink>
    </Heading>
  )
}

export default Title
